import { Navigate, useLocation, useParams } from "react-router-dom";

const LegacyModuleRedirect = ({ nextPrefix }) => {
  const { tenantSlug, "*": remainder = "" } = useParams();
  const { search, hash } = useLocation();
  const suffix = remainder ? `/${remainder}` : "";

  return (
    <Navigate
      to={`/${tenantSlug}/${nextPrefix}${suffix}${search}${hash}`}
      replace
    />
  );
};

export default LegacyModuleRedirect;
